// controls/textarea.js — version React Composant + JSON Schema native
import React, { useState, useEffect } from "react";
import CommonControls from "./inc/Common";
import { debug } from "utils";
import "./controls.css";

/**
 * Création d’un champ texte long (textarea)
 * Conforme JSON Schema draft 2020-12
 */
export function createTextareaField() {
  return {
    type: "string",
    title: "Texte long",
    "x-ui": "textarea",
    "x-required": true,
    maxLength: 5000,
    rows: 4,
    autoHeight: false,
    "x-placeholder": "",
  };
}

/**
 * Éditeur du champ texte long (FieldEditor) — version composant React
 */
export function EditTextareaField({ field, onChange }) {
  const [rows, setRows] = useState(field.rows ?? 4);
  const [maxLength, setMaxLength] = useState(field.maxLength ?? 5000);
  const [autoHeight, setAutoHeight] = useState(field.autoHeight || false);
  const [placeholder, setPlaceholder] = useState(field["x-placeholder"] || "");

  // Synchronisation vers le parent (FormBuilder)
  useEffect(() => onChange("rows", rows), [rows]);
  useEffect(() => onChange("maxLength", maxLength), [maxLength]);
  useEffect(() => onChange("autoHeight", autoHeight), [autoHeight]);
  useEffect(() => onChange("x-placeholder", placeholder), [placeholder]);

  return (
    <>
      <CommonControls field={field} onChange={onChange} />

      {/* ---- Nombre de lignes visibles ---- */}
      <div className="mb-3">
        <label className="form-label">Nombre de lignes visibles</label>
        <input
          type="number"
          className="form-control form-control-sm compact"
          placeholder="ex : 4"
          value={rows}
          onChange={(e) => setRows(Number(e.target.value))}
        />
      </div>

      {/* ---- Longueur maximale ---- */}
      <div className="mb-3">
        <label className="form-label">Longueur maximale</label>
        <input
          type="number"
          className="form-control form-control-sm compact"
          placeholder="ex : 5000"
          value={maxLength}
          onChange={(e) => setMaxLength(Number(e.target.value))}
        />
      </div>

      {/* ---- Auto-hauteur ---- */}
      <div className="form-check mb-3">
        <input
          className="form-check-input"
          type="checkbox"
          id={`autoHeight_${field.id}`}
          checked={autoHeight}
          onChange={(e) => setAutoHeight(e.target.checked)}
        />
        <label className="form-check-label" htmlFor={`autoHeight_${field.id}`}>
          Ajuster automatiquement la hauteur selon le contenu
        </label>
      </div>

      {/* ---- Placeholder ---- */}
      <div className="mb-3">
        <label className="form-label">Texte indicatif (placeholder)</label>
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="ex : Votre message ici..."
          value={placeholder}
          onChange={(e) => setPlaceholder(e.target.value)}
        />
      </div>
    </>
  );
}

/**
 * Compatibilité avec le FieldEditorRegistry
 */
export const editTextareaField = (props) => <EditTextareaField {...props} />;
/* =========================================================
   🧩 FRONT — rendu du champ texte long (textarea)
   ========================================================= */
export const RenderTextareaField = ({
  field,
  value,
  onChange,
  className,
  isReadOnly,
  errors   // valeur string éventuelle : "Champ requis"
}) => {

  const rows = field.rows ?? 4;
  const maxLength = field.maxLength ?? 5000;
  const autoHeight = field.autoHeight || false;
  const placeholder = field["x-placeholder"] || "";
  const isRequired =
    field["x-effective-required"] === true ||
    field["x-required"] === true;
  const handleChange = (e) => {
    const val = e.target.value;
    if (autoHeight) {
      e.target.style.height = "auto";
      e.target.style.height = e.target.scrollHeight + "px";
    }

    onChange?.(val);
  };

  return (
    <div
      className={`
        fb-field fb-text
        ${isRequired ? "fb-required" : ""}
        ${field["x-bloc-class"] || ""}
        ${className || ""}
      `}
    >
      {/* Label */}
      {field.title && (
        <label className="form-label">
          {field.title}
        </label>
      )}
      {/* Textarea */}
      <textarea
        className={`
          form-control
          ${field["x-control-class"] || ""}
          ${errors ? "is-invalid" : ""}
        `}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        value={value || ""}
        readOnly={isReadOnly}
        onChange={handleChange}
        style={autoHeight ? { overflow: "hidden", resize: "none" } : {}}
      ></textarea>

      {/* Message d’erreur */}
      {/* errorMessage && (
        <div className="invalid-feedback d-block mt-1">
          {errorMessage}
        </div>
      ) */}

    </div>
  );
};
